import * as React from 'react';

export interface ICheckboxFilterItemProps {
    id: string,    
    name: string,
    label: string,
    value: any,
    isChecked: boolean,
    disabled: boolean,
    onChangeHandler(value: any): void
}

export interface ICheckboxFilterItemState {
    isChecked: boolean
}

export class CheckboxFilterItem extends React.Component<ICheckboxFilterItemProps, ICheckboxFilterItemState>{

    constructor(props: ICheckboxFilterItemProps) {

        super(props);
        this.state = { isChecked: false };
    }

    componentWillReceiveProps(nextProps: ICheckboxFilterItemProps): void {
        this.setState({ isChecked: nextProps.isChecked });
    }

    public onChangeHandler(value: any): void {
        this.setState((prevState) => {
            return { isChecked: !prevState.isChecked };
        });
        this.props.onChangeHandler(value);
    }
    
    render() {
        return (
            <div className={'filters-checkbox-item' + (this.props.disabled ? ' disabled' : '')}>
                <input type="checkbox"
                    id={this.props.id}
                    name={this.props.name}
                    value={this.props.value}
                    checked={this.state.isChecked}
                    disabled={this.props.disabled}
                    onChange={() => this.onChangeHandler(this.props.value)} />
                <label htmlFor={this.props.id}>{this.props.label}</label>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/checkbox-filter-item.tsx